import ImageCustom from '@/components/Image'
import clsx from 'clsx'
import React from 'react'

export declare type ThumbOneOverrideProps = {
    position?: "bottom" | "top" | string
    classes?: string
    cols?: number
    caption?: string
    image?: {
        data?: {
            attributes?: {
                url?: string
            }
        }
    }
}
interface SectionThumbProps {
    thumb: ThumbOneOverrideProps
    section: {
        heading: string
    }
}

const SectionThumb: React.FC<SectionThumbProps> = ({ thumb, section }) => {

    return (
        <div className={clsx(thumb.classes, `col-${thumb.cols || 12}`)}>
            <figure className="w-100 rounded post__thumb position_relative">
                <ImageCustom src={thumb?.image?.data?.attributes?.url}
                    fill
                    alt={section.heading}
                    className="object-fit-cover" />
                {thumb.caption &&
                    <figcaption>
                        {thumb.caption}
                    </figcaption>}
            </figure>
        </div>
    )
}

export default SectionThumb